var countMenuDropdownItem = document.querySelectorAll('.menu-dropdown-header .menu-dropdown-item ');
var countMenuDropdownSubColumns = document.querySelectorAll('.menu-dropdown-header .menu-dropdown-sub-columns');
if (countMenuDropdownItem.length === 1) {
  for (var i = 0; i < countMenuDropdownSubColumns.length; i++) {
    countMenuDropdownSubColumns[i].classList.add('only-parent-item');
  }
}